import { height } from "dom-helpers";

export default () => ({
  previewContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#F9F9F9",
    padding: "20px 0",
    // position: "absolute",
    // left: 100,
    // right: 100,
  },
  rootContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "white",
    paddingRight: 20,
  },
  tabsIndicator: {
    backgroundColor: "#333",
    height: 3
  },
  tabsRoot: {
    flexGrow: 1,
    minHeight: 40,
  },
  frameContainer: {
    border: "none",
    minHeight: "calc(100vh - 180px)",
  },
  subjectInput: {
    background: "rgba(255, 255, 255, 0.8)",
    border: "1px solid #dadada",
    marginBottom: 20,
    height: 50
  },
  subjectLabel: {
    fontWeight: 600,
    fontSize: 18
  },
  rightButtons: { display: "flex", justifyContent: "flex-end", alignItems: "center" },
  separator: { height: 30, width: 0, border: "1px solid #EEEEEE", margin: "0 10px" },
  mainPreviewContainer: {
    display: "flex",
    position: "relative",
    minHeight: "76vh",
  },
  arrowIcon: {
    // padding: 10,
    width: 57,
    //height: "100vh",
    cursor: "pointer",
    display: "flex",
    alignItems: "baseline",
    justifyContent: "center",
    paddingTop: 400,
    "&&:hover": {
      background: "#f2fbfe",
      color: "#26BBED !important"
    },
    "&&icon": {
      fontSize: "40px !important"
    }
  },
  arrowIconNull: {
    width: 57,
    padding: 10,
    //height: "100vh",
    display: "flex",
    alignItems: "center",
  },
  iFrameCanvas: {
    background: "white",
    border: "1px solid #DADADA",
    transition: 'all .2s',
    maxWidth: "100%"
  },

  tabRoot: {
    textTransform: "capitalize",
    color: "#33333380",
    fontSize: 14,
    minHeight: 40,
    fontWeight: "normal",
    padding: 0,
    minWidth: "max-content",
    marginRight: 30,
    "&:hover": {
      color: "#26BBED",
    },
  },
  tabSelected: {
    color: "#333 !important",
    fontWeight: "bold",
  },
  printImg: {
    width: 30,
    height: 30,
    cursor: "pointer"
  },
  printDescription: {
    color: "#333",
    fontSize: 16,
    lineHeight: "24px",
  },
  printDescription2: {
    color: "#333",
    fontSize: 14,
    lineHeight: "20px",
    marginTop: 20,
    "& span": {
      fontWeight: 600
    }
  },
  printImages: {
    marginTop: 8,
    marginLeft: 18,
    width: 258,
  },
  printBtn: {
    textTransform: "none"
  },
  loader: {
    position: "absolute",
    width: "-webkit-fill-available",
    height: "-webkit-fill-available",
  },
  rightButtonCSS: {
    fontWeight: 400,
    fontSize: 14,
    textTransform: "none"
  },
  inactiveCSS: {
    color: "rgba(51, 51, 51, 0.5)"
  },
  emailContainer: {
    width: "100%",
    padding: "0px 23px",
    height: "calc(100vh - 211px)"
  },
  iFrameClass: {
    width: 200,
    height: 200,
    border: "none",
  },
  imgFrameClass: {
    width: 200,
    height: 200,
    border: "none",
    overflow: "hidden",
    background: "white",
    "& img": {
      width: 200,
      height: 200,
      // margin: "43px 0px 0px -31px",
      // transform: "scale(1.3)"
    }
  },
  bottomContainer: {
    height: 54,
    display: 'flex',
    alignItems: "center",
    justifyContent: "space-between",
    background: "white",
    borderTop: "1px solid #dadada",
    paddingLeft: 6
  },
  switchContainer: {
    marginTop: -15,
  },
  eventTitle: {
    fontSize: 14,
    lineHeight: "20px",
    color: "rgba(51, 51, 51, 1)"
  },
  updatedText: {
    fontSize: 12,
    lineHeight: "18px",
    color: "rgba(51, 51, 51, 0.5)",
  },
  emails: {
    display: 'flex',
  },
  bannerBtnStyle: {
    display: "flex",
    margin: 'auto',
    marginBottom: 12,
    fontSize: 12,
    alignItems: "center",
    justifyContent: 'space-between',
    textTransform: "none",
    border: "none !important",
    "&:hover path": {
      fill: "#26bbed",
      border: "none !important",
    }
  },
  iconStyle: {
    marginLeft: 6
  },
  dialogRoot: {
    width: 500,
    background: "white"
  },
  modalButtonStyle: {
    textTransform: "none",
    marginLeft: 12
  },
  titleStyle: {
    fontWeight: 600
  },
  fontDetails: {
    fontFamily: "Open Sans !important"
  },
  buttonsContainer: {
    display: "flex",
    marginTop: 32,
    justifyContent: "right"
  },
  marginTop: {
    marginTop: 24
  },
  loaderContainer: {
    height: 300,
    position: "inherit"
  },
  tooltipKeyStyle: {
    opacity: 0.75,
  },
})

export const editableHeroTitleStyles = () => ({
  label: {
    fontFamily: 'Open Sans',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 400,
    letterSpacing: 0,
    textAlign: 'left',
    color: '#444'
  },
  heroTitleTextField: {
    border: '1px solid #eee',
    padding: '4px 50px'
  },
  heroTitleInput: {
    fontFamily: 'Open Sans',
    fontSize: 28,
    fontStyle: 'normal',
    fontWeight: 600,
    letterSpacing: 0,
    textAlign: 'center',
    lineHeight: 1
  }
});

export const editableHeroMessageTitleStyles = () => ({
  label: {
    fontFamily: 'Open Sans',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 400,
    letterSpacing: 0,
    textAlign: 'left',
    color: '#444'
  },
  heroMessageTitleInput: {
    fontFamily: 'Open Sans',
    fontSize: 28,
    fontStyle: 'normal',
    fontWeight: 400,
    letterSpacing: 0,
    textAlign: 'center',
    lineHeight: 1
  }
});

export const editableHeroMessageBodyStyles = () => ({
  label: {
    fontFamily: 'Open Sans',
    fontSize: 12,
    fontStyle: 'normal',
    fontWeight: 400,
    letterSpacing: 0,
    textAlign: 'left',
    color: '#444'
  },
  heroMessageBodyInput: {
    fontFamily: 'Open Sans',
    fontSize: 18,
    fontStyle: 'normal',
    fontWeight: 400,
    letterSpacing: 0,
    textAlign: 'left',
    lineHeight: 1.2
  }
});